// extracted by mini-css-extract-plugin
export var bigText = "YtzC_";
export var boldText = "pj2JF";
export var compact = "gmI_o";
export var container = "XyuIi";
export var contentContainer = "gqdUO";
export var dismissButtonContainer = "Qsp8R";
export var full = "HktdY";
export var iconColumn = "E3izA";
export var iconColumnHidden = "wogVu";
export var iconMCLCompact = "tCfqa";
export var iconMCLFull = "oumRS";
export var iconMCLMedium = "ZEv2h";
export var iconSCLCompact = "jlSWg";
export var iconSCLFull = "ew2Nd";
export var iconSCLMedium = "bUA06";
export var medium = "Rc6C3";
export var nudgeActionButton = "_B9zR";
export var nudgeBar = "zeokq";
export var nudgeBarNoImage = "P1lmn";
export var nudgedIcon = "PRUZA";
export var smallText = "LCpDt";
export var textColumn = "uiVCk";
export var textContent = "Qrjn_";